import type { INotification, NotificationFilters } from '../types/notification.types'

import { BaseService } from '../../http-layer/service/base.service'

export class NotificationService extends BaseService {
  constructor() {
    super({
      baseURL: 'CLIENTPORTAL_SERVER_URL',
      basePath: 'notifications/v2',
    })
  }

  async getNotifications(filters?: NotificationFilters): Promise<{ data: INotification[] }> {
    const params: Record<string, any> = {}

    if (filters?.isRead !== undefined) {
      params.read = filters.isRead
    }
    if (filters?.limit) {
      params.limit = filters.limit
    }
    if (filters?.previousId) {
      params.previousId = filters.previousId
    }
    if (filters?.pageSort) {
      params.pageSort = filters.pageSort
    }

    return this.get('', { params })
  }

  async markNotificationAsRead(notificationId?: string, refId?: string): Promise<{ data: any }> {
    const params: Record<string, any> = {}

    if (notificationId) {
      params.notificationId = notificationId
    } else if (refId) {
      params.refId = refId
    }

    return this.post('/read', null, { params })
  }
}
